<template>
  <div
    @click="onUploadFile()"
    class="answer-file-icon sj-icon-add-image"
    style="font-size: 75px;color: #c0c4cc;"></div>
</template>

<script>
import QuestionReview from '../../question-review.js'
import UpdateImage from '../../components/UploadImage'
import UpdateFile from '../../components/UploadFile'
import UploadQrcode from '../../components/UploadQrcode'

export default {
  components: {},
  mixins: [],
  props: {
    question: Object,
    type: String,
    uploadData: Object,
    datetime: String,
    questionIndex: Number,
  },
  data () {
    return {
      accept: {
        photo: ['image/jpeg', 'image/png', 'image/gif'],
        record: ['audio/mp3', 'audio/wav'],
        video: ['video/mp4', 'video/webm'],
      },
    }
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    ...Vuex.mapActions(['uploadOrderReviewFile']),
    onUploadFile () {
      if (this.type === 'photo') {
        UpdateImage({
          request: this.uploadOrderReviewFile,
          name: 'file',
          datetime: this.datetime,
          data: this.uploadData,
          questionIndex: this.questionIndex,
          callback: (src) => {
            QuestionReview().addEvidence(this.question.id, {
              type: this.type,
              src,
            })
          },
        })
      } else if (this.type === 'qrcode') {
        UploadQrcode({
          request: this.uploadOrderReviewFile,
          name: 'file',
          datetime: this.datetime,
          data: this.uploadData,
          questionIndex: this.questionIndex,
          callback: (data) => {
            QuestionReview().addEvidence(this.question.id, {
              type: this.type,
              ...data,
            })
          },
        })
      } else {
        UpdateFile({
          name: 'file',
          data: this.uploadData,
          accept: this.accept[this.type],
          questionIndex: this.questionIndex,
          maxSize: 15360,
          callback: (response) => {
            response.urls.forEach((src, index) => {
              let data = {
                type: this.type,
                src: src
              }
              if (this.type === 'video') {
                data.cover = response.videoThumbnailUrls[index] || ''
              }
              QuestionReview().addEvidence(this.question.id, data)
            })
          },
        })
      }
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/AnswerFileList/AnswerFileUpload.vue